/**
* quiqlist.app.js
*
*/
function testAppJS() {
    const toggle = document.getElementById("testing");
    if (!toggle || !label) return;
}
/**
 * A background request answered "you have no account selected" — the session's account was lost, most
 * likely evicted from the shared cache while the page sat idle. The page itself is now a shell over a
 * tenant that no longer exists, so reload onto the dashboard, which prompts for an account and says why.
 * Kendo grids and jQuery both route through ajaxError, which is why this is global rather than per-widget.
 */
$(document).ajaxError(function (event, xhr) {
    if (xhr.status !== 409) return;

    let payload;
    try {
        payload = JSON.parse(xhr.responseText);
    } catch {
        return;
    }

    if (payload && payload.error === "account_required") {
        window.location.assign("/?selectAccount=1");
    }
});

/**
* admin-edit-user.js
* Handles: password strength, show/hide password, confirm match,
*          copy-to-clipboard, status toggle label, remove-membership confirm,
*          unsaved-changes warning.
*/

(function () {
    "use strict";

    /* ── DOM ready ─────────────────────────────────────────────── */
    document.addEventListener("DOMContentLoaded", function () {
        initStatusToggle();
        initPasswordStrength();
        initTogglePasswordVisibility();
        initPasswordMatchValidation();
        initRemoveMembershipConfirm();
        initCopyButtons();
        initUnsavedChangesWarning();
        initAutoHideAlerts();
    });

    /* ── 1. Status Toggle Label ─────────────────────────────────── */
    function initStatusToggle() {
        const toggle = document.getElementById("isActiveSwitch");
        const label = document.getElementById("statusLabel");
        if (!toggle || !label) return;

        toggle.addEventListener("change", function () {
            label.textContent = this.checked ? "Active" : "Inactive";
        });
    }

    /* ── 2. Password Strength Meter ──────────────────────────────── */
    function initPasswordStrength() {
        const input = document.getElementById("newPassword");
        const fillEl = document.getElementById("pwStrengthFill");
        const labelEl = document.getElementById("pwStrengthLabel");
        if (!input || !fillEl) return;

        input.addEventListener("input", function () {
            const score = scorePassword(this.value);
            const config = [
                { pct: 0, color: "#e9ecef", text: "" },
                { pct: 25, color: "#ef4444", text: "Weak" },
                { pct: 50, color: "#f97316", text: "Fair" },
                { pct: 75, color: "#eab308", text: "Good" },
                { pct: 100, color: "#22c55e", text: "Strong" },
            ][score];

            fillEl.style.width = config.pct + "%";
            fillEl.style.backgroundColor = config.color;
            if (labelEl) labelEl.textContent = config.text;
        });
    }

    /** Returns 0–4 */
    function scorePassword(pw) {
        if (!pw) return 0;
        let score = 0;
        if (pw.length >= 8) score++;
        if (pw.length >= 12) score++;
        if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
        if (/\d/.test(pw)) score++;
        if (/[^A-Za-z0-9]/.test(pw)) score++;
        return Math.min(4, score);
    }

    /* ── 3. Show / Hide Password ─────────────────────────────────── */
    function initTogglePasswordVisibility() {
        document.querySelectorAll(".eu-btn-toggle-pw").forEach(function (btn) {
            btn.addEventListener("click", function () {
                const targetId = this.dataset.target;
                const input = document.getElementById(targetId);
                if (!input) return;
                const isText = input.type === "text";
                input.type = isText ? "password" : "text";
                const icon = this.querySelector("i");
                if (icon) {
                    icon.classList.toggle("bi-eye", isText);
                    icon.classList.toggle("bi-eye-slash", !isText);
                }
            });
        });
    }

    /* ── 4. Password Confirm Match ───────────────────────────────── */
    function initPasswordMatchValidation() {
        // Find all forms that have password validation enabled
        document.querySelectorAll("[data-pw-validate]").forEach(function (form) {
            const pw1 = form.querySelector("[data-pw-new]");
            const pw2 = form.querySelector("[data-pw-confirm]");
            const errEl = form.querySelector("[data-pw-error]");

            if (!pw1 || !pw2) return;

            function checkMatch() {
                const mismatch = pw2.value.length > 0 && pw1.value !== pw2.value;
                if (errEl) errEl.style.display = mismatch ? "block" : "none";
                pw2.setCustomValidity(mismatch ? "Passwords do not match" : "");
            }

            pw1.addEventListener("input", checkMatch);
            pw2.addEventListener("input", checkMatch);

            form.addEventListener("submit", function (e) {
                checkMatch();
                if (pw2.validationMessage) {
                    e.preventDefault();
                    pw2.reportValidity();
                }
            });
        });
    }

    /* ── 5. Remove Membership Confirmation ──────────────────────── */
    function initRemoveMembershipConfirm() {
        document.querySelectorAll(".eu-remove-membership-form").forEach(function (form) {
            form.addEventListener("submit", function (e) {
                const btn = form.querySelector(".eu-btn-remove-membership");
                const account = btn ? btn.dataset.account : "this account";
                if (!confirm(`Remove user from "${account}"? This cannot be undone.`)) {
                    e.preventDefault();
                }
            });
        });
    }

    /* ── 6. Copy-to-Clipboard ────────────────────────────────────── */
    function initCopyButtons() {
        document.querySelectorAll(".eu-copy-btn").forEach(function (btn) {
            btn.addEventListener("click", function () {
                const text = this.dataset.copy;
                if (!text) return;
                navigator.clipboard.writeText(text).then(() => {
                    const icon = this.querySelector("i");
                    if (icon) {
                        icon.classList.replace("bi-copy", "bi-check2");
                        setTimeout(() => icon.classList.replace("bi-check2", "bi-copy"), 1800);
                    }
                });
            });
        });
    }

    /* ── 7. Unsaved Changes Warning ──────────────────────────────── */
    function initUnsavedChangesWarning() {
        const profileForm = document.getElementById("profileForm");
        if (!profileForm) return;

        let isDirty = false;

        profileForm.querySelectorAll("input, select, textarea").forEach(function (el) {
            el.addEventListener("change", function () { isDirty = true; });
            el.addEventListener("input", function () { isDirty = true; });
        });

        profileForm.addEventListener("submit", function () { isDirty = false; });

        window.addEventListener("beforeunload", function (e) {
            if (isDirty) {
                e.preventDefault();
                e.returnValue = "You have unsaved changes. Leave anyway?";
            }
        });
    }

    /* ── 8. Auto-dismiss Alerts ──────────────────────────────────── */
    function initAutoHideAlerts() {
        document.querySelectorAll(".eu-alert").forEach(function (el) {
            setTimeout(function () {
                const bsAlert = bootstrap.Alert.getOrCreateInstance(el);
                if (bsAlert) bsAlert.close();
            }, 6000);
        });
    }

})();
/**
 * date-range-filter.js
 * Handles:
 *  - Compare toggle show/hide
 *  - Auto-calculate CompareEndDate (disabled) from primary range + CompareStartDate
 *  - Date guards (end >= start)
 *  - Apply button wiring (calls fetchAndUpdate if defined on page, else form submit)
 */
(function () {
    "use strict";

    // Wait for jQuery and Kendo to be available
    function waitForKendo(callback) {
        if (typeof jQuery !== 'undefined' && typeof kendo !== 'undefined' && kendo.ui && kendo.ui.DatePicker) {
            callback();
        } else {
            setTimeout(function() { waitForKendo(callback); }, 50);
        }
    }

    function today() {
        var d = new Date(); d.setHours(0, 0, 0, 0); return d;
    }

    function addDays(date, n) {
        var d = new Date(date); d.setDate(d.getDate() + n); return d;
    }

    // Find a Kendo DatePicker whose name attribute ends with the given suffix
    // e.g. "StartDate" matches name="DateFilter.StartDate" or name="StartDate"
    function kdpBySuffix(root, suffix) {
        var sel = '[name$=".' + suffix + '"], [name="' + suffix + '"]';
        var el = root.querySelector(sel);
        return el ? $(el).data("kendoDatePicker") : null;
    }

    function setKdp(picker, date) {
        if (picker && date) picker.value(date);
    }

    // ── Calculate CompareEndDate ──────────────────────────────────────────────
    // CompareEndDate = CompareStartDate + (primaryEnd - primaryStart)
    function recalcCompareEnd(root) {
        var spPrimary = kdpBySuffix(root, "StartDate");
        var epPrimary = kdpBySuffix(root, "EndDate");
        var spCompare = kdpBySuffix(root, "CompareStartDate");
        var epCompare = kdpBySuffix(root, "CompareEndDate");

        if (!spPrimary || !epPrimary || !spCompare || !epCompare) return;

        var ps = spPrimary.value();
        var pe = epPrimary.value();
        var cs = spCompare.value();

        if (ps && pe && cs) {
            var rangeMs = pe.getTime() - ps.getTime();
            var computed = new Date(cs.getTime() + rangeMs);
            // Enable briefly to set value (Kendo won't set value on a disabled picker)
            epCompare.enable(true);
            epCompare.value(computed);
            epCompare.enable(false);
        }
    }

    function initInstance(root) {
        var toggleInput = root.querySelector('input[type="checkbox"][name$="CompareEnabled"]');
        var compareGroup = root.querySelector("#drf-compare-group");
        var infoBar = root.querySelector("#drf-info-bar");
        var applyBtn = root.querySelector("#drf-apply-btn");

        if (!applyBtn) return;

        // Ensure Kendo DatePickers are initialized
        // This handles cases where Kendo scripts loaded after DatePicker HTML was rendered
        if (typeof kendo === 'undefined' || !kendo.ui || !kendo.ui.DatePicker) {
            console.warn('Kendo DatePicker not available yet');
            return;
        }

        // Reinitialize any DatePicker inputs that haven't been bound yet
        root.querySelectorAll('input[class*="k-input"]:not([data-role])').forEach(function(input) {
            if (input.type === 'text' && !$(input).data('kendoDatePicker')) {
                try {
                    $(input).kendoDatePicker();
                } catch (e) {
                    console.warn('Failed to initialize DatePicker:', e);
                }
            }
        });

        // ── Compare toggle ──────────────────────────────────────────────────────
        function setCompareVisible(on) {
            root.dataset.compare = on ? "true" : "false";
            if (compareGroup) {
                compareGroup.classList.toggle("drf-hidden", !on);
                compareGroup.setAttribute("aria-hidden", !on);
                // Enable/disable compare start picker
                var csp = kdpBySuffix(root, "CompareStartDate");
                if (csp) csp.enable(on);
            }
            if (infoBar) infoBar.classList.toggle("drf-hidden", !on);

            if (on) {
                // Auto-suggest compare start = one period before primary start
                var sp = kdpBySuffix(root, "StartDate");
                var ep = kdpBySuffix(root, "EndDate");
                if (sp && ep && sp.value() && ep.value()) {
                    var rangeMs = ep.value() - sp.value();
                    var autoStart = new Date(sp.value().getTime() - rangeMs - 86400000);
                    var csp2 = kdpBySuffix(root, "CompareStartDate");
                    if (csp2) csp2.value(autoStart);
                }
                recalcCompareEnd(root);
            }
        }

        if (toggleInput) {
            setCompareVisible(toggleInput.checked);   // init on load
            toggleInput.addEventListener("change", function () {
                setCompareVisible(this.checked);
            });
        }

        // ── Wire recalc on primary date changes ─────────────────────────────────
        $(document).ready(function () {
            var sp = kdpBySuffix(root, "StartDate");
            var ep = kdpBySuffix(root, "EndDate");
            var csp = kdpBySuffix(root, "CompareStartDate");

            if (sp) {
                sp.bind("change", function () {
                    // Guard: StartDate <= EndDate
                    var sv = sp.value(), ev = ep ? ep.value() : null;
                    if (sv && ev && sv > ev && ep) ep.value(sv);
                    recalcCompareEnd(root);
                });
            }
            if (ep) {
                ep.bind("change", function () {
                    var sv = sp ? sp.value() : null, ev = ep.value();
                    if (sv && ev && ev < sv && sp) sp.value(ev);
                    recalcCompareEnd(root);
                });
            }
            if (csp) {
                csp.bind("change", function () {
                    recalcCompareEnd(root);
                });
            }
        });

        // ── Apply button ────────────────────────────────────────────────────────
        // If the page defines window.drfFetchAndUpdate, call it (AJAX chart mode).
        // Otherwise fall back to submitting the parent form.
        applyBtn.addEventListener("click", function (e) {
            e.preventDefault();
            if (typeof window.drfFetchAndUpdate === "function") {
                window.drfFetchAndUpdate();
            } else {
                var form = root.closest("form");
                if (form) { applyBtn.classList.add("is-loading"); form.submit(); }
            }
        });
    }

    document.addEventListener("DOMContentLoaded", function () {
        // Wait for Kendo to be fully loaded before initializing date pickers
        waitForKendo(function() {
            document.querySelectorAll(".drf-bar").forEach(initInstance);
        });
    });

    window.DateRangeFilter = {
        init: function () {
            waitForKendo(function() {
                document.querySelectorAll(".drf-bar:not([data-drf-init])").forEach(function (r) {
                    r.dataset.drfInit = "1"; 
                    initInstance(r);
                });
            });
        }
    };
})();